import { ModuleFE_VariableRelation } from './ModuleFE_VariableRelation.js';
export const ModulePackFE_VariableRelation = [ModuleFE_VariableRelation];
//# sourceMappingURL=module-pack.js.map